// src/components/Reports/ReportChart.js
import React from 'react';
import { Card, Alert, Spinner } from 'react-bootstrap';
import { Line } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import { getChartOptions } from '../../utils/reportUtils';
import ChartWrapper from '../UI/ChartWrapper';

// Registrace potřebných Chart.js komponent
Chart.register(...registerables);

const ReportChart = ({
                         reportType,
                         reportData,
                         loading,
                         error,
                         selectedWebsites,
                         isExporting,
                         onExport,
                         onRefresh,
                         onTimeRangeChange,
                         dateRange
                     }) => {
    // Generování opcí pro graf podle typu reportu
    const chartOptions = getChartOptions(reportType);

    // Získání titulu podle typu reportu
    const getReportTitle = () => {
        switch (reportType) {
            case 'uptime':
                return 'Monitoring dostupnosti webů';
            case 'performance':
                return 'Výkon webů v čase';
            case 'security':
                return 'Bezpečnostní problémy';
            case 'seo':
                return 'SEO skóre v čase';
            default:
                return 'Report';
        }
    };
    // Přidání kontroly, zda data existují a jsou formátována správně
    const hasValidData = reportData &&
        reportData.datasets &&
        reportData.datasets.length > 0 &&
        reportData.datasets.some(ds => ds.data && ds.data.some(val => val !== null && val !== undefined));

    // Pokud nejsou vybrány žádné weby, zobrazíme výzvu k výběru
    if (selectedWebsites.length === 0) {
        return (
            <Card className="shadow-sm mb-4">
                <Card.Body className="text-center py-5">
                    <i className="fas fa-chart-line fa-3x text-muted mb-3"></i>
                    <h5>Vyberte alespoň jeden web pro zobrazení reportu</h5>
                    <p className="text-muted">Weby můžete vybrat v seznamu vlevo</p>
                </Card.Body>
            </Card>
        );
    }

    // Definice časových rozsahů pro volbu období
    const timeRanges = [
        { value: '7days', label: '7 dní' },
        { value: '30days', label: '30 dní' },
        { value: '90days', label: '90 dní' },
    ];

    return (
        <ChartWrapper
            type="line"
            data={hasValidData ? reportData : { labels: [], datasets: [] }}
            options={chartOptions}
            title={getReportTitle()}
            height={350}
            loading={loading}
            error={error}
            emptyMessage={!hasValidData
                ? "Pro vybrané weby nejsou k dispozici žádná data"
                : "Nejsou k dispozici žádná data pro zobrazení grafu"}
            exportOptions={{
                csv: true,
                png: true,
                pdf: true
            }}
            onRefresh={onRefresh}
            onExport={onExport}
            timeRanges={timeRanges}
            selectedTimeRange={dateRange}
            onTimeRangeChange={onTimeRangeChange}
        />
    );
};

export default ReportChart;